import React from 'react'
import IncidentPerAttribute from './IncidentPerAttribute'

const ValidIncidentsPerStatus = () => {
    const monitorReport = false;

    return (
        <>
            <IncidentPerAttribute monitorReport={monitorReport} attributeType="COMMENTSTATUS" disaggregation="sex" />
        </>
    )
}

export default ValidIncidentsPerStatus

